import axios from '@/lib/axios';
import { CancelRequestParams } from '../types';

const createCancel = (data: CancelRequestParams, custCode: string | undefined) => {
  return axios.post(`/facility/flat_rates/terminate_cancels/${custCode}/cancel_create`, data);
}

export default createCancel;